module.exports = __webpack_public_path__ + "static/media/room.b1286742.svg";